import './index.less'


// WEBPACK FOOTER //
// ./ecology9/base/wea-input-normal/style/index.js